module.exports = __webpack_public_path__ + "static/media/roof.2a6f195f.svg";